<template >
  <div id="smart-button-container">
    <div style="text-align: right; background: white">
      <div class="p-3 rtl">
        <strong> מידע חשוב לפני שמתחילים: </strong>
      </div>
      <div class="px-3 rtl">
        - עלות המשחק היא
        <strong> 29 שקלים </strong>

        לכל מכשיר נייד.
      </div>
      <div class="px-3 pt-1 rtl">- אפשר לשלם בכרטיס אשראי או עם PayPal.</div>

      <div class="px-3 pt-1 rtl">- המשחק מתחיל מייד אחרי התשלום.</div>
      <div class="px-3 pt-1 rtl">
        - המשחק יהיה נגיש במהלך 24 שעות אחרי התשלום עבור מכשיר זה.
      </div>
      <div class="px-3 pb-4 pt-1 rtl">- אישור תשלום יישלח אליכם למייל</div>
      <div class="row rtl px-3 pb-4 pt-1 rtl my-4">
        <div class="col-3 pl-0">קוד קופון:</div>
        <input class="col-5" v-model="coupon" type="text" />
        <button class="col-2 mr-3" @click="checkCoupon">שלח</button>
      </div>

      <div id="paypal-button-container"></div>

      <div v-if="confirmation === true" class="over center">
        <div
          class="p-3 myModal2"
          style="background-color: rgb(84, 163, 49); color: white"
        >
          <div class="mt-3 text-center">
            <div
              class="mt-3 rtl"
              style="font-family: 'noot', cursive; font-size: 40px"
            >
              התשלום עבר בהצלחה, אפשר להתחיל
            </div>
            <div class="mt-3 text-center">{{ translation.noPassword }}</div>
          </div>
          <div class="font-weight-bold mt-5 mb-2 h4 text-center"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  data() {
    return {
      coupon: "",
      buyerName: "",
      confirmation: false,
    };
  },
  mounted() {
    const script = document.createElement("script");
    // DEMO
    // script.src =
    //   "https://www.paypal.com/sdk/js?client-id=AT8H_86S3uUnwgMYtKwJiJXrjzpis2FDYUmr8da45d46wuHhFGIgniH3NgNIdJeyKnUEQa-pyXJHpK9B&currency=ILS&locale=he_IL";
    //LIVE
    script.src =
      "https://www.paypal.com/sdk/js?client-id=ARLYyNiETX705wbleW13jVZbEmlHUs6HCxKDpDyYpyu4akvxajWf7U9AmzPMf789jos4EpjBvJc-zy2-&currency=ILS&locale=he_IL";
    // data - sdk - integration - source = "button-factory";
    script.addEventListener("load", this.initPayPalButton);
    document.body.appendChild(script);
    this.waitForAnswer();
  },

  computed: {},
  methods: {
    checkCoupon() {
      if (this.coupon == "יפויפו") {
        this.$router.push("/startGame");
      } else {
        console.log("BAD COUPON", this.coupon);
      }
    },
    waitForAnswer() {
      // console.log("In wait for answer");
      var waitForAnswerLoop = setInterval(() => {
        if (localStorage.getItem("details")) {
          console.log("details from local storage");
          this.details = JSON.parse(localStorage.getItem("details"));
          // console.log("this.details", this.details);
          clearInterval(waitForAnswerLoop);
          if (this.details.status == "COMPLETED") {
            setTimeout(() => {
              localStorage.removeItem("details");
            }, 86400000);
            this.$router.push("/startGame");
          } else {
            alert("התשלום לא עבר בהצלחה, נא לנשות שוב או אם כרטיס אשראי אחר.");
          }
        }
        // else {
        //   console.log("STILL WAITING IN waitForAnswerLoop");
        // }
      }, 200);
    },
    initPayPalButton() {
      paypal
        .Buttons({
          style: {
            shape: "rect",
            color: "blue",
            layout: "vertical",
            label: "paypal",
          },

          createOrder: function (data, actions) {
            return actions.order.create({
              purchase_units: [
                {
                  description:
                    "רכישת משחק ניווט ביפו. המשחק יהיה נגיש לי במהלך 24 שעות.",
                  amount: { currency_code: "ILS", value: 29 },
                },
              ],
            });
          },

          onApprove: function (data, actions) {
            console.log("data and actions", data, actions);
            return actions.order.capture().then(function (details) {
              console.log("details", details);
              localStorage.setItem("details", JSON.stringify(details));
              // this.buyerName = details.payer.name.given_name;
              // this.confirmation = true;
              alert(
                "Transaction completed by " +
                  details.payer.name.given_name +
                  "!"
              );
            });
          },

          onError: function (err) {
            console.log(err);
          },
        })
        .render("#paypal-button-container");
    },
  },
};
</script>

<style scoped>
.myModal2 {
  width: 320px;
  border-radius: 10px;
  display: block;
  margin: 0px auto;
  margin-top: calc(50vh - 170px);
  background-color: rgb(84, 163, 49);
  color: white;
  border: solid 2px white;
}
.over {
  position: fixed;
  top: 0px;
  font-size: 18px;
  width: 100vw;
  max-width: 590px;
  height: 100vh;
  background: url("../../static/img/escalade.png") no-repeat center center;
  background-size: cover;
  background-color: rgba(0, 0, 0, 0.9);
}
.center {
  display: block;
  margin: 0px auto;
}
.rtl {
  direction: rtl;
}
.container {
  margin-top: 16px;
  background-color: rgba(248, 242, 242, 0.2);
  font-size: 20px;
  /* height: calc(100vh - 82px); */
}
</style>
